export default "__VITE_ASSET__BHdwlbou__"